import mainApi from '@/common/api/urls'
import { rbacAuthGrayAtom, rbacAuthResourcesAtom } from '@/common/recoil/atom'
import { commonRequest } from '@/common/utils/request'
import { getLoginShopid, getRbacAuthResources, setRbacAuthGrayConfig, setGrayConfig, setRbacAuthResources, getIsCloudUI, getAccountType, getLoginShopList,
  getMerchantMode, MerchantModeEnum,
  setRbacAuthResourcesWithLoginAccountId,
  getLoginUinfo,
} from '@RootCommon/utils'
import { useRecoilState } from 'recoil'
import { owlAddJsInfo, owlReportMetrics } from '@RootCommon/utils/owl'
import { loganLog } from '@RootCommon/utils/logan'
import { getRbacAuthResourcePApi } from '@/common/api/prefetchApis'
import { ACCOUNT_TYPE } from '@RootCommon/constants'

const GRAY_KEY = 'rbac'
const GRAY_KEY_MERCHANT_MALL = 'merchant_market'

export default function () {
  const [rbacAuthGray, setRbacAuthGray] = useRecoilState(rbacAuthGrayAtom)
  const [rbacAuthResources, setRbacAuthResourcesState] = useRecoilState(rbacAuthResourcesAtom)

  // rbac全局灰度接口
  const getRbacAuthGrayConfig = async () => {
    try {
      const grayData = await commonRequest.post(mainApi.rbacAuthGrayConfig, {
        grayKey: [GRAY_KEY, GRAY_KEY_MERCHANT_MALL],
      }, { autoToast: false })
      const isRbacAuth = grayData[GRAY_KEY]
      console.log(isRbacAuth)
      setRbacAuthGray(isRbacAuth)
      setRbacAuthGrayConfig(isRbacAuth)
      setGrayConfig(grayData)
      if (isRbacAuth) {
        // 灰度开，新权限生效数量, 一天一次？
        owlReportMetrics({ B_RBAC_AUTH_GRAY_TRUE: 1 }, {})
      }
    } catch (err) {
      console.log(err)
      owlAddJsInfo('RBAC 灰度接口异常', err)
    }
  }

  // 权限资源接口，依赖shopId
  // 和灰度接口同时请求，灰度未开，则不使用资源
  const getRbacAuthResource = async (curShopId?) => {
    try {
      const shopId = curShopId ?? getLoginShopid()
      const accountType = getAccountType()
      const shopInfoList = getLoginShopList()
      const selectMode = getMerchantMode()
      let authes = []
      if (getIsCloudUI()
        && [ACCOUNT_TYPE.CUSTOMER, ACCOUNT_TYPE.SUB_CUSTOMER, ACCOUNT_TYPE.CUSTOMER_GROUP, ACCOUNT_TYPE.SUB_CUSTOMER_GROUP].includes(accountType)
        && selectMode === MerchantModeEnum.MultiStore
      ) {
        const singleAuthes = await getRbacAuthResourcePApi({ shopId: shopInfoList[0].shopId })
        const multiAuthes = await getRbacAuthResourcePApi({ shopId: 0 })
        // 根据 resourceCode 去重
        authes = Array.from(
          new Map([...singleAuthes, ...multiAuthes].map(item => [item.resourceCode, item])).values()
        )
      } else {
        authes = await getRbacAuthResourcePApi({ shopId })
      }
      if (authes.length > 0) {
        console.log(authes, 'authes~~')
        const authResources = authes.map(item => item.resourceCode)
        setRbacAuthResourcesState(authResources)
        setRbacAuthResources(authResources)
        // 新权限拉取成功数量, 根据门店数量计算
        owlReportMetrics({ B_RBAC_AUTH_CODE_SUCCESS: 1 }, {})
      }
      // 白名单逻辑，请求当前登录账号rbac权限
      let authesWithLoginAccountId = []
      authesWithLoginAccountId = await getRbacAuthResourcePApi({ shopId, accountId: getLoginUinfo().acctId })
      if (authesWithLoginAccountId.length > 0) {
        const authResourcesWithLoginAccountId = authesWithLoginAccountId.map(item => item.resourceCode)
        setRbacAuthResourcesWithLoginAccountId(authResourcesWithLoginAccountId)
      }
    } catch (err) {
      console.log(err)
      setRbacAuthResourcesState(rbacAuthResources)
      setRbacAuthResources(rbacAuthResources)
      owlAddJsInfo('RBAC 权限资源接口异常', err)
      loganLog({ err,  rbacAuthGray, storageRbacAuthResources: getRbacAuthResources(), rbacAuthResources })
    }
  }

  return {
    rbacAuthGray,
    getRbacAuthGrayConfig,
    getRbacAuthResource,
  }
}
